interface AuthHeader {
	'x-app-id': string;
	Authorization?: string;
	'x-request-context'?: string;
}

export function getAuthorizationHeaders() {
	const jwt = sessionStorage.getItem('jwt');
	const org = sessionStorage.getItem('org');

	const headers: AuthHeader = {
		'x-app-id': 'GCM',
	};

	if (jwt) {
		headers.Authorization = `Bearer ${jwt}`;
	}

	if (org) {
		headers['x-request-context'] = org;
	}

	return headers;
}
